/**
 * Constants related to the Enode charging functionality
 */

/**
 * Smart charging states
 * @enum {string}
 */
export const SmartChargingStates = {
  OVERRIDDEN: 'PLAN:EXECUTING:OVERRIDDEN',
  STOPPED: 'PLAN:EXECUTING:STOPPED',
  STOPPED_AWAITING_PRICES: 'PLAN:EXECUTING:STOPPED:AWAITING_PRICES',
  STARTING: 'PLAN:EXECUTING:STARTING',
  STOPPING: 'PLAN:EXECUTING:STOPPING',
};

/**
 * Charging actions
 * @enum {string}
 */
export const ChargeActions = {
  START: 'START',
  STOP: 'STOP',
};

/**
 * Charging action states
 * @enum {string}
 */
export const ChargeActionStates = {
  PENDING: 'PENDING',
  CONFIRMED: 'CONFIRMED',
  FAILED: 'FAILED',
  CANCELLED: 'CANCELLED',
};